export default class DisableEvidenceCtrl {
  constructor ($scope, $mdDialog, PortfolioSrv, PortfolioModalSrv) {
  // constants
    var disableVm = this
    const sharedVariable     = PortfolioModalSrv.getVariable()

    disableVm.evidence    = sharedVariable.evidence

  // methods
    disableVm.close           = close
    disableVm.disableEvidence = disableEvidence

    function close () {
      PortfolioModalSrv.setVariable({status : false})
      return $mdDialog.hide()
    }  

    function disableEvidence () {
      let header = {
        blogId : disableVm.evidence.blogId
      }
      PortfolioSrv.disableEvidence.disable(header).$promise.then((dataReturn) => {
        if (dataReturn.status) {
          PortfolioModalSrv.setVariable({status : dataReturn.status})
          return $mdDialog.hide()      
        }
      })
    }
  }
}

DisableEvidenceCtrl.$inject = ['$scope', '$mdDialog', 'PortfolioSrv', 'PortfolioModalSrv']



// WEBPACK FOOTER //
// ./src/app/u-faculty/portfolio/myPortfolio/modals/disableEvidenceCtrl.js